module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    class: [(this.$store.state.permissaoNegada.permissaoNegada.show === true) ? 'in show' : '', 'modal fade permissaoNegada'],
    attrs: {
      "id": "permissaoNegada",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    class: [(this.$store.state.permissaoNegada.permissaoNegada.status) ? 'sucesso' : 'falhou', 'modal-header']
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), (this.$store.state.permissaoNegada.permissaoNegada.status) ? _c('h4', {
    staticClass: "modal-title alert-title"
  }, [_vm._v(" Sucesso! "), _c('span', [_c('b-icon-unlock-fill')], 1)]) : _c('h4', {
    staticClass: "modal-title alert-title"
  }, [_vm._v(" Acesso negado! "), _c('span', [_c('b-icon-lock-fill')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body alert-body",
    domProps: {
      "innerHTML": _vm._s(this.$store.state.permissaoNegada.permissaoNegada.msg)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("Fechar")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10881da4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/permissoes/PermissaoNegada.vue
// module id = 951
// module chunks = 1